
import Lottie from 'react-lottie';
import lottieData from '../../../assets/images/uploadLayerLoading.json';

function Loading({width = 100, height= 100}) {
  const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: lottieData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <Lottie
      options={defaultOptions}
      height={height}
      width={width}
    />
  );
}

export default Loading;
